import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { FIGMA_ICON_MAP, type FigmaIconName } from './figma-icon-overview';

@Component({
  selector: 'ion-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  host: {
    '[class.small]': "size() === 's'",
    '[class.large]': "size() === 'l'",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly icon = input.required<FigmaIconName>();
  readonly size = input<'l' | 'm' | 's'>('m');
  readonly iconUrl = computed(() => `url("${FIGMA_ICON_MAP[this.icon()]}")`);
}
